import { useCallback, useEffect, useMemo } from 'react';
import { User } from 'firebase/auth';
import { useAdvertChannelsStore } from '../stores/advertChannels.store';

export const useAdvertChannels = (user: User | undefined, advertUUID: string | undefined, opts: { loadOnMount?: boolean } = {}) => {
  const { loadOnMount = true } = opts;
  const { byAdvert, loading, error, load, set } = useAdvertChannelsStore();
  useEffect(() => { if (advertUUID && loadOnMount) { load(user, advertUUID); } }, [advertUUID, loadOnMount, load, user]);
  const channelUUIDs = useMemo(() => (advertUUID ? (byAdvert[advertUUID] || []) : []), [byAdvert, advertUUID]);
  const setChannels = useCallback((uuids: string[]) => { if (advertUUID) { set(user, advertUUID, uuids); } }, [set, user, advertUUID]);
  return { channelUUIDs, loading, error, setChannels, reload: () => advertUUID && load(user, advertUUID) };
};
